<template>
	<div class="foot_box flex2">
		<div class="nav_item flex2" :class="curtAct == index ? 'act_sty' : ''" v-for="(item, index) in footList" :key="item.title"
			@mouseover="handMouseOver(index)" @mouseout="handMouseOut(index)" @click.stop="handleTabClick(index, item.path)">
			<img :src="item.sel || curtAct == index ? item.imgact : item.imgdeft" />
			<span>{{ item.title }}</span>

			<div class="anti_fake flex3" v-if="index == 0">
				<div class="af_box flex1">
					<div class="af_item" @mouseover="fw1 = true" @mouseout="fw1 = false" @click.stop="jumpPage(1)">
						<img v-if="fw1" src="@/images/footer/new_act.png" />
						<img v-else src="@/images/footer/new.png" />
						<p>全新三位一体防伪</p>
					</div>
					<div class="af_item" @mouseover="fw2 = true" @mouseout="fw2 = false" @click.stop="jumpPage(2)">
						<img v-if="fw2" src="@/images/footer/old_act.png" />
						<img v-else src="@/images/footer/old.png" />
						<p>三重八关防伪体系</p>
					</div>
				</div>
			</div>
			<div class="online_store" v-if="index == 4">
				<div class="os_box flex2">
					<img @click="toMall('https://mall.jd.com/index-55944.html')" src="@/images/footer/jd.png" />
					<img @click="toMall('https://jiannanchun.tmall.com/')" src="@/images/footer/tm.png" />
				</div>
			</div>
			<div class="anti_fake flex3" v-if="index == 5">
				<div class="af_box flex1">
					<div class="af_item">
						<img :src="ma4[0]" />
						<p>剑南春微信订阅号</p>
					</div>
					<div class="af_item">
						<img :src="ma4[1]" />
						<p>剑南春微信服务号</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { mapState, mapActions } from "vuex";
export default {
	data() {
		return {
			fw1: false,
			fw2: false,
            ma4: [],//0订阅号、1服务号、2小红书、3视频号
            bsinfo:{},
		};
	},
	computed: {
		...mapState(["footList", "headAct", "curtAct"]),
	},
    created(){
        this.basicInfo();
    },
	methods: {
        // 基础信息
		async basicInfo() {
			const res = await this.$api.basicInfo();
			if (res.code == 1) {
				this.bsinfo = res.data;
				this.ma4 = this.bsinfo.images.split(',');//0订阅号、1服务号、2小红书、3视频号
				for (let i = 0; i < this.ma4.length; i++) {
					this.ma4[i] = this.$staticImg + this.ma4[i]
				}
			}
		},
		handMouseOver(index) {
			this.footList[index].sel = true;
		},
		handMouseOut(index) {
			this.footList[index].sel = false;
		},
		handleTabClick(index, path) {
			if (path) {
				if (path.indexOf("http") != -1) {
					window.location.href = path;
				} else {
					this.$router.push(path);
				}
			}
		},
		jumpPage(a) {
			if (a == 1) this.$router.push('/seNews');
			if (a == 2) this.$router.push('/seOld');
		},
		toMall(url) {
            window.open(url, '_blank');
			// window.location.href = url;
		},
	},
};
</script>
<style lang="scss">
.act_sty {
	background-color: #d43235 !important;
	span {
		color: #fff !important;
	}
}
.foot_box {
	position: fixed;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: 3000;
	height: 74px;
	box-shadow: 0 -2px 2px 0 rgba(0, 0, 0, 0.1);
	background-color: hsla(0, 0%, 100%, 0.85);
	.nav_item {
		width: 183px;
		height: 74px;
		flex-wrap: wrap;
		align-content: center;
		cursor: pointer;
		border-right: 1px solid #dadbdc;
		position: relative;
		&:nth-child(1) {
			border-left: 1px solid #dadbdc;
		}
		img {
			width: 38px;
			height: auto;
			margin-top: 2px;
		}
		span {
			margin-top: 8px;
			width: 100%;
			text-align: center;
		}
		.anti_fake {
			position: absolute;
			background-color: #fff;
			bottom: 74px;
			z-index: 1;
			display: none;
			.af_box {
				width: 400px;
				height: 220px;
				.af_item {
					width: 200px;
					img {
						width: 127px;
						height: 127px;
					}
					p {
						text-align: center;
						font-size: 14px;
						margin-top: 5px;
						color: #666;
					}
				}
				.af_item:hover {
					p {
						color: #d43235;
					}
				}
			}
		}
		.online_store {
			position: absolute;
			bottom: 74px;
			left: 0;
			right: 0;
			z-index: 1;
			background-color: #fff;
			display: none;
			.os_box {
				height: 74px;
				img {
					width: 36px;
					height: 36px;
					margin: 0 18px;
				}
			}
		}
	}
	.nav_item:hover {
		background-color: #d43235;
		.anti_fake {
			display: block;
		}
		.online_store {
			display: block;
		}
		span {
			color: #fff;
		}
	}
}
</style>